import { formatDate } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text, Title } from '../../../components/presentation/Text'
import { useFormReply } from './_load/FormReplyLoader'
import Center from '../../../components/helpers/Center'
import Icon from '../../../components/shapes/Icon'
import Separator from '../../../components/helpers/Separator'

const PageContent = () => {
  const { t } = useTranslation('listForms')
  const formReply = useFormReply()
  const place = formReply?.place

  const titleMessage = formReply.form.configuration?.titleMessage
  const bodyMessage = formReply.form.configuration?.bodyMessage

  const titleDefault = t('successTitle')
  const bodyMessageDefault = `${t('successBody')}${!!place ? ` , ${place.name}` : ''}.`

  return (
    <>
      <Separator weight={6} />
      <Center>
        <Icon name="BsTrophy" size="2rem" />
      </Center>
      <Separator weight={6} />
      <Title size="h4" align="center">
        {titleMessage ?? titleDefault}
      </Title>
      <Text align="center">{bodyMessage ?? bodyMessageDefault}</Text>
      <Separator weight={2} />
      <Text align="center" size="small">
        {formatDate('DD/MM/YYYY HH:mm', formReply?.insertedAt)}
      </Text>
      <Separator weight={8} />
    </>
  )
}

export default PageContent
